<template>
  <div>
    <div>
      <div class="" id='selectedOffersInnerDiv'>
        <div @scroll='topScroll($event)' id='changesApproveScrollWrapper' class="scrollWrapper" :style='{width: `${scrollableWidth}`}'>
          <div id='simScrollbar' class='simulateScrollDiv' :style='{width:  `${scrollableChildrenWidth * information.length}rem`}'>
          </div>
        </div>
        <div class="inline-block" id='selectedOffersHeaderContainer'>
          <data-table :data='headers' :styles='tableStyles.offersListHeaderStyles'></data-table>
        </div>
        <div @scroll='bottomScroll($event)' id='selectedOffersDataContainer' class="inline-block scrollable" :style='{width: scrollableWidth}'>
          <div class="inline-block" :style='{width: `${information.length * scrollableChildrenWidth}rem`}'>
            <div
              class="inline-block"
              v-for='data in information'
              :style='{width: `${scrollableChildrenWidth}rem`}'>
              <data-table
                :handleEvent='childEvent'
                :data='data'
                :stringPadding='detailedDataPadding'
                :styles='tableStyles.offersListDataStyle'
                :functions='childEvent'>
              </data-table>
            </div>
          </div>
        </div>
      </div>
      <div class="width_full" :style='mainContainerStyle.mainStyle.tableButton'>
        <button
        type="button"
        @click='submitApproveLock'
        :class="{'primary-green-bg': hasChanges, 'light-grey-text': !hasChanges, 'width_half': true}"
        :disabled="!hasChanges"
        >
          Approve with changes and lock offer
        </button>
     </div>
    </div>
    <!-- <div v-if='confirmPopUp'>
      <pop-up
        :closePopUp='closePopUp'
        :type='popUpType'
        :styles='mainContainerStyle'
        :data='confirmData'>
      </pop-up>
    </div> -->
  </div>
</template>

<script>
import DataTable from 'src/components/shared/flexTables/DataTable'
import { tableStyles } from './tableStyles'
import { mainContainerStyle } from 'src/components/pop-up/mainContainerStyle'
import { mapActions, mapGetters } from 'vuex'
import * as NameSpace from '../../store/NameSpace'
import PopUp from 'src/components/pop-up/Main'
import { cloneDeep, unionBy } from 'lodash'
// import * as CODE from 'src/constants/Constants'
import { TableHeightByFixedWidth } from 'src/Services/tableLayoutHelper/height'
import { validateInputField } from 'src/Services/Validation'
import {
  REGULAR_RETAIL,
  SUGGESTED_SB_ALLOWANCE,
  SUGGESTED_OI_ALLOWANCE,
  SUGGESTED_RETAIL_SAVINGS,
  SUGGESTED_RETAIL,
  RETAIL_FUNDING,
  FUNDING_MERCHANT_ADJUSTED,
  APPROVE_WITH_CHANGES,
  APPROVE_WITH_NO_CHANGES
} from 'src/constants/Constants'

export default {
  data () {
    return {
      tableStyles: tableStyles,
      scrollableChildrenWidth: 15,
      detailedDataPadding: {
        length: 15
      },
      scrollableWidth: '0px',
      mainContainerStyle: mainContainerStyle,
      approveWithLockInput: {},
      landingScreen: '/pending-offers',
      confirmPopUp: false,
      popUpType: 'Confirmation Query',
      modifiedIndexValuePair: {},
      commonOverrideIndexValuePair: {},
      editedHeaders: [],
      editedFields: [],
      code: null,
      hasChanges: false,
      copyData: [],
      msg: ['Values must meet the following:-', '1. Should only be numeric.', '2. Can have max four digits before and two digits after decimal point.'],
      // msg: ['Values must meet the following:-', '1. Should only be numeric.', '2. Can optionally start by + or -', '3. Can have max four digits before and two digits after decimal point.'],
      rrPos: 0,
      sbPos: 0,
      oiPos: 0,
      srsPos: 0,
      srPos: 0,
      fundPos: 0,
      previewDataArray: [],
      previewHeaderArray: [],
      childEvent: this.childEvent
    }
  },
  props: ['handleEvent', 'confirmEventApproveWithChanges'],
  computed: {
    ...mapGetters({
      gettersAprroveWithChangesOriginal: NameSpace.GET_APPROVE_WITH_CHANGES_OLD,
      gettersAprroveWithChanges: NameSpace.GET_APPROVE_WITH_CHANGES,
      gettersSelectedOffer: NameSpace.GET_SELECTED_OFFER_NAME,
      gettersOfferFilterInput: NameSpace.GET_AGG_INPUT_FILTER_DATA,
      gettersAprroveWithChangesNew: NameSpace.GET_APPROVE_WITH_CHANGES_RESULT,
      gettersAggInputData: NameSpace.GET_AGG_INPUT_FILTER_DATA
    }),
    information () {
      let data = this.gettersAprroveWithChanges.data
      if (data) {
        // this.copyData = cloneDeep(data)
        return data
      } else {
        this.hardResetApproveWithChanges()
        this.pop({
          header: 'STATUS',
          message: `There is no item to show.`,
          buttons: {
            accept: {
              text: 'Ok'
            }
          },
          type: ''
        })
        this.handleEvent({goHome: true, path: this.landingScreen})
        return []
      }
    },
    itemRemoved () {
      return this.gettersAprroveWithChanges.itemRemoved
    },
    headers () {
      let headers = this.gettersAprroveWithChanges.headers
      if (headers) {
        this.rrPos = headers.map(e => { return e.key }).indexOf(REGULAR_RETAIL)
        this.sbPos = headers.map(e => { return e.key }).indexOf(SUGGESTED_SB_ALLOWANCE)
        this.oiPos = headers.map(e => { return e.key }).indexOf(SUGGESTED_OI_ALLOWANCE)
        this.srsPos = headers.map(e => { return e.key }).indexOf(SUGGESTED_RETAIL_SAVINGS)
        this.srPos = headers.map(e => { return e.key }).indexOf(SUGGESTED_RETAIL)
        this.fundPos = headers.map(e => { return e.key }).indexOf(RETAIL_FUNDING)
        this.maPos = headers.map(e => { return e.key }).indexOf(FUNDING_MERCHANT_ADJUSTED)
      }
      return headers
    },
    confirmData () {
      // let reduceData = cloneDeep(this.information)
      // reduceData.pop()
      return {
        contents: this.editedFields,
        headers: this.editedHeaders,
        code: this.code
      }
    }
  },
  watch: {
    itemRemoved () {
      if (this.itemRemoved) {
        this.pop({
          header: 'REMOVE ITEM',
          message: `Successfully Remove the item.`,
          buttons: {
            accept: {
              text: 'Ok'
            }
          },
          type: 'SUCCESS'
        })
      }
    },
    gettersAprroveWithChangesNew () {
      if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.success) {
        this.handleEvent(this.gettersAprroveWithChangesNew.result)
        // this.pop({
        //   header: 'Approve Offer',
        //   message: `Successfully Approved Offer Name`,
        //   buttons: {
        //     accept: {
        //       text: 'Ok'
        //     }
        //   },
        //   type: 'SUCCESS'
        // })
      } else if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.result && this.gettersAprroveWithChangesNew.result.error) {
        this.pop({
          header: 'ERROR',
          message: this.gettersAprroveWithChangesNew.result.error.map(e => {
            let key = Object.keys(e).pop()
            return `${key}: ${e[key]}`
          }),
          buttons: {
            accept: {
              text: 'Try again?'
            }
          },
          type: 'ERROR'
        })
      } else if (this.gettersAprroveWithChangesNew && !this.gettersAprroveWithChangesNew.success) {
        this.pop({
          header: 'Approve Offer',
          message: `Failed In Approve Offer`,
          buttons: {
            accept: {
              text: 'Try again?'
            }
          },
          type: 'ERROR'
        })
      }
    }
  },
  methods: {
    ...mapActions({
      fetchApproveWithChangs: NameSpace.FETCH_APPROVE_WITH_CHANGES,
      submitOfferLock: NameSpace.SUBMIT_OFFER_LOCK,
      hardResetApproveWithChanges: NameSpace.HARD_RESET_APPROVE_WITH_CHANGES,
      actionRemoveItem: NameSpace.ACTION_REMOVE_ITEM_BY_ID,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION
    }),
    getScrollableWidth () {
      try {
        if (
          document.getElementById('selectedOffersInnerDiv') &&
          document.getElementById('selectedOffersHeaderContainer')
        ) {
          let selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth
          let selectedOffersHeaderContainer = document.getElementById('selectedOffersHeaderContainer').clientWidth
          let paddingOnInnerDiv = 40
          this.modifyTableHeightByData('#selectedOffersHeaderContainer')
          this.modifyTableHeightByData('#selectedOffersDataContainer div')
          return `${selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv}px`
        }
      } catch (e) {
        return 0
      }
    },
    topScroll (e) {
      let actualWrapper = document.getElementById('selectedOffersDataContainer')
      actualWrapper.scrollLeft = e.target.scrollLeft
    },
    bottomScroll (e) {
      let actualWrapper = document.getElementById('changesApproveScrollWrapper')
      actualWrapper.scrollLeft = e.target.scrollLeft
    },
    formKeyValues (bool, record) {
      let key = this.headers[record.index].key
      for (let j = 0; j < this.information.length - 1; j++) {
        if (bool) {
          let itemKey = this.information[j].itemId
          this.addEditedValues(itemKey, key, record.value)
        } else {
          if (record.commonOverride) {
            let itemKey = this.information[j].itemId
            this.addEditedValues(itemKey, key, this.information[j][record.index].value)
          } else {
            let commonOverrideKeys = Object.keys(this.commonOverrideIndexValuePair)
            if (commonOverrideKeys.length) {
              for (let n = 0; n < commonOverrideKeys.length; n++) {
                let value = this.commonOverrideIndexValuePair[commonOverrideKeys[n]]
                if (value && value.trim().length) {
                  let itemKey = this.information[j].itemId
                  key = this.headers[commonOverrideKeys[n]].key
                  this.addEditedValues(itemKey, key, value)
                } else {
                  if (j === record.itemIndex) {
                    let itemKey = this.information[record.itemIndex].itemId
                    this.addEditedValues(itemKey, key, record.value)
                  } else {
                    let itemKey = this.information[j].itemId
                    this.addEditedValues(itemKey, key, this.information[j][record.index].value)
                  }
                }
              }
            } else {
              if (j === record.itemIndex) {
                let itemKey = this.information[record.itemIndex].itemId
                this.addEditedValues(itemKey, key, record.value)
              } else {
                let itemKey = this.information[j].itemId
                this.addEditedValues(itemKey, key, this.information[j][record.index].value)
              }
            }
          }
        }
      }
    },
    addEditedValues (itemKey, key, value) {
      if (!this.approveWithLockInput[itemKey]) {
        this.approveWithLockInput[itemKey] = {
          [key]: value
        }
      } else {
        let oriObject = this.approveWithLockInput[itemKey]
        oriObject[key] = value
      }
    },
    removeItem (record) {
      this.modifiedIndexValuePair = {}
      this.commonOverrideIndexValuePair = {}
      let itemId = this.information[record.itemIndex].itemId
      this.hardResetApproveWithChanges()
      this.actionRemoveItem({offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id, itemId})
    },
    confrimToRemove (record) {
      this.pop({
        header: 'REMOVE ITEM',
        message: `Are you sure to remove the item? : ${record.value}`,
        type: '',
        buttons: {
          accept: {
            text: 'OKAY',
            action: this.removeItem.bind(this, record)
          }
        }
      })
    },
    setCommonOverrideValue (isCommonOverride, valueIndex, value) {
      if (isCommonOverride) {
        let commonOverrideObject = this.information[this.information.length - 1]
        value = value + ''
        this.$set(commonOverrideObject[valueIndex], 'value', value)
      }
    },
    getNewValueToSet (y, valueIndex, newValue, itemObjectArray) {
      let originalObject = this.gettersAprroveWithChangesOriginal[y]
      let co = this.information[this.information.length - 1][valueIndex]
      if (typeof co.value !== 'undefined' && co.value.length > 0 && (co.value[0] === '+' || co.value[0] === '-')) {
        newValue = Number(originalObject[valueIndex].value) + Number(co.value)
        itemObjectArray[valueIndex].change = true
      } else if (typeof co.value !== 'undefined' && co.value.trim().length > 0) {
        newValue = Number(co.value)
        itemObjectArray[valueIndex].change = true
      } else {
        newValue = Number(originalObject[valueIndex].value)
        itemObjectArray[valueIndex].change = false
      }
      return newValue
    },
    performOperation (isCommonOverride, isDelta, valueIndex, value, y) {
      let itemObjectArray = this.information[y]
      let key = this.headers[valueIndex].key
      if (key === FUNDING_MERCHANT_ADJUSTED) {
        this.calculateFundingByMA(isCommonOverride, isDelta, value, valueIndex, itemObjectArray, y)
      } else if (key === SUGGESTED_RETAIL_SAVINGS) {
        this.calculateSRAndRFbySRS(isCommonOverride, isDelta, valueIndex, value, this.srPos, null, itemObjectArray, y)
      } else if (key === SUGGESTED_RETAIL) {
        this.calculateSRAndRFbySRS(isCommonOverride, isDelta, valueIndex, value, null, this.srsPos, itemObjectArray, y)
      } else if (key === SUGGESTED_SB_ALLOWANCE) {
        let newValue
        if (value.length === 0) {
          newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray)
        } else {
          itemObjectArray[valueIndex].change = true
          if (isDelta) {
            let oldValue = itemObjectArray[valueIndex].value
            newValue = Number(oldValue) + Number(value)
          } else {
            newValue = Number(value)
          }
        }
        itemObjectArray[valueIndex].value = newValue.toFixed(2)
        // let commonOverrideObject = this.information[this.information.length - 1]
        // this.setCommonOverrideValue(isCommonOverride, valueIndex, value)
        this.calculateRetailFundingBySBorOI(isCommonOverride, newValue, null, itemObjectArray, valueIndex, y)
      } else if (key === SUGGESTED_OI_ALLOWANCE) {
        let newValue
        if (value.length === 0) {
          newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray)
        } else {
          itemObjectArray[valueIndex].change = true
          if (isDelta) {
            let oldValue = itemObjectArray[valueIndex].value
            newValue = Number(oldValue) + Number(value)
          } else {
            newValue = Number(value)
          }
        }
        itemObjectArray[valueIndex].value = newValue.toFixed(2)
        // this.setCommonOverrideValue(isCommonOverride, valueIndex, value)
        this.calculateRetailFundingBySBorOI(isCommonOverride, null, newValue, itemObjectArray, valueIndex, y)
      }
    },
    calculate (isDelta, valueIndex, itemIndex, value, isCommonOverride) {
      if (isCommonOverride) {
        for (let y = 0; y < this.information.length - 1; y++) {
          this.performOperation(isCommonOverride, isDelta, valueIndex, value, y)
        }
      } else {
        this.performOperation(isCommonOverride, isDelta, valueIndex, value, itemIndex)
      }
      this.buttonCondtion()
      // this.hardResetApproveWithChanges(this.information)
    },
    buttonCondtion () {
      let hasChanges = false
      for (let i = 0; i < this.information.length; i++) {
        let item = this.information[i]
        for (let k = 0; k < item.length; k++) {
          let record = item[k]
          if (record.change) {
            hasChanges = true
            this.information[i].change = true
            break
          } else {
            // this.hasChanges = false
            this.information[i].change = false
          }
        }
      }
      if (hasChanges) {
        this.hasChanges = true
      } else {
        this.hasChanges = false
      }
    },
    calculateFundingByMA (isCommonOverride, isDelta, value, valueIndex, itemObjectArray, y) {
      let newValue
      // set own value
      if (value.length === 0) {
        newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray)
      } else {
        itemObjectArray[valueIndex].change = true
        if (isDelta) {
          let oldValue = itemObjectArray[valueIndex].value
          newValue = Number(oldValue) + Number(value)
        } else {
          newValue = Number(value)
        }
      }
      let sbAllowance = itemObjectArray[this.sbPos].value
      let oiAllowance = itemObjectArray[this.oiPos].value
      let srs = itemObjectArray[this.srsPos].value
      let sboi = Number(sbAllowance) + Number(oiAllowance)
      let newPspRetailFunding = (Number(srs) - sboi) - newValue
      if (newValue > itemObjectArray[this.fundPos].value) {
        // itemObjectArray[valueIndex].value = itemObjectArray[this.maPos].value
        this.hasChanges = false
        var cloneNewValue = cloneDeep(newValue)

        itemObjectArray[valueIndex].change = false
        let errorMessage = itemObjectArray[0].value + ' - Pet Depot Funding [Merchant Adjusted](' + cloneNewValue + ') should not be more than PSP Retail Funding (' + itemObjectArray[this.fundPos].value + ').'
        this.showErrorMessage(errorMessage)
        if (isCommonOverride) {
          this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
          this.calculate(false, valueIndex, y, '', isCommonOverride)
          this.calculate(false, this.fundPos, y, '', isCommonOverride)
        } else {
          newValue = this.getNewValueToSet(y, valueIndex, '', itemObjectArray)
          itemObjectArray[valueIndex].value = newValue.toFixed(2)
          this.calculateFundingByMA(isCommonOverride, false, newValue, valueIndex, itemObjectArray, y)
          // itemObjectArray[this.fundPos].value = this.getNewValueToSet(y, this.fundPos, '', itemObjectArray)
          // itemObjectArray[this.fundPos].value = newPspRetailFunding.toFixed(2)
        }
        return
        // newPspRetailFunding = 0.00
      } else {
        itemObjectArray[valueIndex].value = newValue.toFixed(2)
        if (newPspRetailFunding < 0) {
          itemObjectArray[this.fundPos].value = 0
        } else {
          itemObjectArray[this.fundPos].value = newPspRetailFunding.toFixed(2)
        }
      }
    },
    calculateSRAndRFbySRS (isCommonOverride, isDelta, valueIndex, value, srPos, srsPos, itemObjectArray, y) {
      let oldValue
      let newValue
      // set common override value else empty due to refresh of component
      this.setCommonOverrideValue(isCommonOverride, valueIndex, value)
      if (value === '') {
        newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray)
      } else {
        itemObjectArray[valueIndex].change = true
        if (isDelta) {
          oldValue = itemObjectArray[valueIndex].value
          newValue = Number(oldValue) + Number(value)
        } else {
          newValue = Number(value)
        }
      }
      let rrValue = itemObjectArray[this.rrPos].value.substring(1)
      if (newValue > rrValue) {
        var cloneNewValue = cloneDeep(newValue)
        if (isCommonOverride) {
          this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
          let originalObject = this.gettersAprroveWithChangesOriginal[y]
          newValue = originalObject[valueIndex].value
        } else {
          newValue = this.getNewValueToSet(y, valueIndex, value, itemObjectArray)
          itemObjectArray[valueIndex].value = newValue.toFixed(2)
        }
        this.hasChanges = false
        itemObjectArray[valueIndex].change = false
        if (srPos) {
          /* The following two lines are used for resetting Manufacturer Suggested Retail Savings, PSP Retail Funding to previous value if Manufacturer Suggested Retail is invalid.
          */
          itemObjectArray[this.srPos].value = this.getNewValueToSet(y, this.srPos, value, itemObjectArray)
          // itemObjectArray[this.fundPos].value = this.getNewValueToSet(y, this.fundPos, value, itemObjectArray)
          // this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y)
          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested Retail Savings(' + cloneNewValue + ')  must be less than Regular Retail.')
          /* The following code must be same code when common override was cleared */
          if (isCommonOverride) {
            this.setCommonOverrideValue(isCommonOverride, this.srPos, '')
            this.setCommonOverrideValue(isCommonOverride, this.srsPos, '')
            // this.calculate(false, this.srsPos, y, '', isCommonOverride)
            // for (let y = 0; y < this.information.length - 1; y++) {
            //   this.performOperation(false, isDelta, this.srPos, this.getNewValueToSet(y, this.srPos, '', itemObjectArray), y)
            // }
          }
        } else if (srsPos) {
          /* The following two lines is for resetting Manufacturer Suggested Retail, PSP Retail Funding to previous value if Manufacturer Suggested Retail Savings is invalid.
          */
          itemObjectArray[this.srsPos].value = this.getNewValueToSet(y, this.srsPos, value, itemObjectArray)
          // itemObjectArray[this.fundPos].value = this.getNewValueToSet(y, this.fundPos, value, itemObjectArray)
          // this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y)
          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested Retail(' + cloneNewValue + ') must be less than Regular Retail.')
          /* The following code must be same code when common override was cleared */
          if (isCommonOverride) {
            this.setCommonOverrideValue(isCommonOverride, this.srsPos, '')
            this.setCommonOverrideValue(isCommonOverride, this.srPos, '')
            // this.calculate(false, this.srPos, y, '', isCommonOverride)
            // for (let y = 0; y < this.information.length - 1; y++) {
            //   this.performOperation(false, isDelta, this.srsPos, this.getNewValueToSet(y, this.srsPos, '', itemObjectArray), y)
            // }
          }
        }
        // return
      }
      // set own new value
      itemObjectArray[valueIndex].value = newValue.toFixed(2)
      let regularRetail = itemObjectArray[this.rrPos].value
      if (regularRetail[0] === '$') {
        regularRetail = regularRetail.substring(1)
      }
      let result = Number(regularRetail) - newValue
      if (srPos) {
        // set new suggested retail
        itemObjectArray[srPos].value = result.toFixed(2)
        this.setCommonOverrideValue(isCommonOverride, srPos, '')
      } else if (srsPos) {
        // set new suggested retail savings
        itemObjectArray[srsPos].value = result.toFixed(2)
        this.setCommonOverrideValue(isCommonOverride, srsPos, '')
      }

      // set PSP funding
      this.calculateRetailFundingBySRS(itemObjectArray)
    },
    setValue (itemObjectArray, valueIndex, data) {
      itemObjectArray[valueIndex].value = data.toFixed(2)
    },
    calculateRetailFundingBySBorOI (isCommonOverride, newSB, newOI, itemObjectArray, valueIndex, y) {
      let addition
      let rrValue = itemObjectArray[this.rrPos].value.substring(1)
      let sb, oi, message
      if (newSB !== null && typeof newSB !== 'undefined') {
        rrValue = Number(rrValue)
        if (newSB > rrValue) {
          var cloneNewSBValue = cloneDeep(newSB)
          if (isCommonOverride) {
            this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
            let originalObject = this.gettersAprroveWithChangesOriginal[y]
            newSB = originalObject[valueIndex].value
          } else {
            newSB = this.getNewValueToSet(y, valueIndex, newSB, itemObjectArray)
          }
          this.hasChanges = false
          itemObjectArray[valueIndex].change = false
          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested SB Allowance(' + cloneNewSBValue + ') must be less than Regular Retail.')
          // itemObjectArray[this.fundPos].value = this.getNewValueToSet(y, this.fundPos, itemObjectArray[this.fundPos].value, itemObjectArray)
          this.setValue(itemObjectArray, valueIndex, newSB)
          // let plus = Number(itemObjectArray[this.oiPos].value) + cloneNewSBValue
          /* The following if statement is for checking (Manufacturer Suggested SB Allowance + Manufacturer Suggested OI Allowance) value >  Retail Savings.
          */
          // if (plus > rrValue) {
          //   itemObjectArray[this.oiPos].value = this.getNewValueToSet(y, this.oiPos, itemObjectArray[this.oiPos].value, itemObjectArray)
          // }
          this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y)
          return
        }
        let oiAllowance = itemObjectArray[this.oiPos].value
        oi = oiAllowance
        addition = newSB + Number(oiAllowance)
        // clear common override
        // this.setCommonOverrideValue(isCommonOverride, this.oiPos, '')
      } else if (newOI !== null && typeof newOI !== 'undefined') {
        rrValue = Number(rrValue)
        if (newOI > rrValue) {
          var cloneNewOIValue = cloneDeep(newOI)
          if (isCommonOverride) {
            this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
            let originalObject = this.gettersAprroveWithChangesOriginal[y]
            newOI = originalObject[valueIndex].value
          } else {
            newOI = this.getNewValueToSet(y, valueIndex, newOI, itemObjectArray)
          }
          this.hasChanges = false
          itemObjectArray[valueIndex].change = false
          this.showErrorMessage(itemObjectArray[0].value + ' - Manufacturer Suggested OI Allowance(' + cloneNewOIValue + ') must be less than Regular Retail.')
          // itemObjectArray[this.fundPos].value = this.getNewValueToSet(y, this.fundPos, itemObjectArray[this.fundPos].value, itemObjectArray)
          this.setValue(itemObjectArray, valueIndex, newOI)
          // let plus = Number(itemObjectArray[this.sbPos].value) + cloneNewOIValue
          /* The following if statement is for checking (Manufacturer Suggested SB Allowance + Manufacturer Suggested OI Allowance) value >  Retail Savings.
          */
          // if (plus > rrValue) {
          //   itemObjectArray[this.sbPos].value = this.getNewValueToSet(y, this.sbPos, itemObjectArray[this.sbPos].value, itemObjectArray)
          // }
          this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y)
          return
        }
        let sbAllowance = itemObjectArray[this.sbPos].value
        sb = sbAllowance
        addition = newOI + Number(sbAllowance)
        // clear common override
        // this.setCommonOverrideValue(isCommonOverride, this.sbPos, '')
      }
      if (addition > rrValue) {
        if (newSB !== null && typeof newSB !== 'undefined') {
          message = ' - (Manufacturer Suggested SB Allowance(' + newSB + ') + Manufacturer Suggested OI Allowance(' + oi + ')) must be less than Regular Retail.'
          if (isCommonOverride) {
            this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
            let originalObject = this.gettersAprroveWithChangesOriginal[y]
            newSB = originalObject[valueIndex].value
            // this.setCommonOverrideValue(isCommonOverride, this.oiPos, '')
            // this.calculate(false, this.oiPos, y, '', isCommonOverride)
            // this.calculate(false, this.sbPos, y, '', isCommonOverride)
            // for (let y = 0; y < this.information.length - 1; y++) {
            //   this.performOperation(isCommonOverride, false, valueIndex, this.getNewValueToSet(y, valueIndex, '', itemObjectArray), y)
            // }
          } else {
            newSB = this.getNewValueToSet(y, valueIndex, newSB, itemObjectArray)
            itemObjectArray[valueIndex].value = newSB.toFixed(2)
          }
          this.setValue(itemObjectArray, valueIndex, newSB)
        } else if (newOI !== null && typeof newOI !== 'undefined') {
          message = ' - (Manufacturer Suggested SB Allowance(' + sb + ') + Manufacturer Suggested OI Allowance(' + newOI + ')) must be less than Regular Retail.'
          if (isCommonOverride) {
            this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
            let originalObject = this.gettersAprroveWithChangesOriginal[y]
            newOI = originalObject[valueIndex].value
            // this.setCommonOverrideValue(isCommonOverride, this.sbPos, '')
            // this.calculate(false, this.oiPos, y, '', isCommonOverride)
            // this.calculate(false, this.sbPos, y, '', isCommonOverride)
            // for (let y = 0; y < this.information.length - 1; y++) {
            //   this.performOperation(isCommonOverride, false, valueIndex, this.getNewValueToSet(y, valueIndex, '', itemObjectArray), y)
            // }
          } else {
            newOI = this.getNewValueToSet(y, valueIndex, newOI, itemObjectArray)
            itemObjectArray[valueIndex].value = newOI.toFixed(2)
          }
          this.setValue(itemObjectArray, valueIndex, newOI)
        }
        this.hasChanges = false
        itemObjectArray[valueIndex].change = false
        this.showErrorMessage(itemObjectArray[0].value + message)
        // itemObjectArray[this.fundPos].value = this.getNewValueToSet(y, this.fundPos, itemObjectArray[this.fundPos].value, itemObjectArray)
        this.calculateFundingByMA(isCommonOverride, false, itemObjectArray[this.maPos].value, this.maPos, itemObjectArray, y)
        return
      } else {
        let srsValue = Number(itemObjectArray[this.srsPos].value)
        let result = srsValue - addition
        result = result - (Number(itemObjectArray[this.maPos].value))
        if (result < 0) {
          result = 0.00
        }
        itemObjectArray[this.fundPos].value = result.toFixed(2)
      }
    },
    calculateRetailFundingBySRS (itemObjectArray) {
      let sbAllowance = itemObjectArray[this.sbPos].value
      let oiAllowance = itemObjectArray[this.oiPos].value
      let addition = Number(sbAllowance) + Number(oiAllowance)
      let newPspRetailFunding = Number(itemObjectArray[this.srsPos].value) - addition
      newPspRetailFunding = newPspRetailFunding - (Number(itemObjectArray[this.maPos].value))
      if (newPspRetailFunding < 0) {
        newPspRetailFunding = 0.00
      }
      itemObjectArray[this.fundPos].value = newPspRetailFunding.toFixed(2)
    },
    childEvent (record) {
      let isCommonOverride = (this.information.length - 1) === Number(record.itemIndex)
      // let errorMessage
      // if (isCommonOverride) {
      //   errorMessage = this.msg
      // } else {
      //   errorMessage = this.msg1
      // }
      if (record && typeof record.event !== 'undefined') {
        this.confrimToRemove(record)
      } else if (record.value || record.value === '') {
        let value = typeof record.value === 'string' ? record.value.trim() : record.value
        let valueIndex = record.index
        let itemIndex = record.itemIndex
        if (value.length === 0) {
          this.calculate(false, valueIndex, itemIndex, value, isCommonOverride)
          return
        }
        // let itemIndex = record.itemIndex
        let response = validateInputField(null, value, isCommonOverride)
        if (response.result) {
          value = ''
          // if (isCommonOverride) {
          //   this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
          // } else {
          //   let itemObjectArray = this.information[itemIndex]
          //   let v = this.getNewValueToSet(itemIndex, valueIndex, value, itemObjectArray)
          //   this.setValue(itemObjectArray, valueIndex, v)
          // }
          this.hasChanges = false
          this.showErrorMessage(this.msg)
        }
        if (isCommonOverride) {
          let firstChar = value[0]
          if (isNaN(firstChar)) {
            this.hasChanges = false
            this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
            this.showErrorMessage(this.msg)
            /* Clear the calculation data if user enter invalid input */
            this.calculate(true, valueIndex, itemIndex, value, isCommonOverride)
          } else {
            // this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
            this.calculate(false, valueIndex, itemIndex, value, isCommonOverride)
          }
        } else {
          this.calculate(false, valueIndex, itemIndex, value, isCommonOverride)
        }
        if (!response.result) {
          // if (isCommonOverride) {
          //   let firstChar = value[0]
          //   if (isNaN(firstChar)) {
          //     this.hasChanges = false
          //     this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
          //     this.showErrorMessage(this.msg)
          //     // this.calculate(true, valueIndex, itemIndex, value, isCommonOverride)
          //   } else {
          //     // this.setCommonOverrideValue(isCommonOverride, valueIndex, value)
          //     this.calculate(false, valueIndex, itemIndex, value, isCommonOverride)
          //   }
          // } else {
          //   this.calculate(false, valueIndex, itemIndex, value, isCommonOverride)
          // }
          // let key = this.headers[record.index].key
          // if (record.commonOverride) {
          //   if (record.value && record.value.trim().length > 0) {
          //     this.commonOverrideIndexValuePair[record.index] = record.value
          //     this.modifiedIndexValuePair[record.index] = record.value
          //     this.formKeyValues(true, record)
          //   } else {
          //     delete this.modifiedIndexValuePair[record.index]
          //     delete this.commonOverrideIndexValuePair[record.index]
          //     delete this.approveWithLockInput[key]
          //     this.formKeyValues(false, record)
          //   }
          // } else {
          //   let itemId = this.information[record.itemIndex].itemId
          //   if (record.value && record.value.trim().length > 0) {
          //     if (!this.modifiedIndexValuePair[itemId]) {
          //       for (let n = 0; n < this.information.length; n++) {
          //         if (n === record.itemIndex) {
          //           this.modifiedIndexValuePair[itemId] = {[record.index]: record.value}
          //         } else {
          //           let itemId = this.information[n].itemId
          //           if (itemId) {
          //             this.modifiedIndexValuePair[itemId] = {[record.index]: this.information[n][record.index].value}
          //           }
          //         }
          //       }
          //     } else {
          //       for (let n = 0; n < this.information.length; n++) {
          //         if (n === record.itemIndex) {
          //           this.modifiedIndexValuePair[itemId][[record.index]] = record.value
          //         } else {
          //           let itemId = this.information[n].itemId
          //           if (itemId) {
          //             this.modifiedIndexValuePair[itemId][[record.index]] = this.information[n][record.index].value
          //           }
          //         }
          //       }
          //     }
          //     // console.log(this.modifiedIndexValuePair)
          //   } else {
          //     delete this.modifiedIndexValuePair[itemId]
          //     delete this.approveWithLockInput[key]
          //   }
          //   this.formKeyValues(false, record)
          // }
          // if (Object.keys(this.modifiedIndexValuePair).length) {
          //   this.hasChanges = true
          // } else {
          //   this.hasChanges = false
          // }
        } else {
          // if (isCommonOverride) {
          //   this.setCommonOverrideValue(isCommonOverride, valueIndex, '')
          // } else {
          //   let itemObjectArray = this.information[itemIndex]
          //   let v = this.getNewValueToSet(itemIndex, valueIndex, value, itemObjectArray)
          //   this.setValue(itemObjectArray, valueIndex, v)
          // }
          // this.hasChanges = false
          // this.showErrorMessage(this.msg)
        }
      }
    },
    showErrorMessage (errorMessage) {
      this.pop({
        header: 'ERROR!!',
        message: errorMessage,
        type: 'ERROR'
      })
    },
    validateCondition (localCopy) {
      let message
      for (let key of Object.keys(localCopy)) {
        let myContent = localCopy[key]
        message = []
        let errorObject = {}
        let oi, sb, rt
        for (let innerKey in myContent) {
          if (innerKey === SUGGESTED_SB_ALLOWANCE) {
            sb = myContent[innerKey]
            sb = sb * 1
          }
          if (innerKey === SUGGESTED_OI_ALLOWANCE) {
            oi = myContent[innerKey]
            oi = oi * 1
          }
          if (innerKey === SUGGESTED_RETAIL_SAVINGS) {
            rt = myContent[innerKey]
            rt = rt * 1
          }
          let res = validateInputField(innerKey, myContent[innerKey], false)
          if (res.msg.length && !errorObject.hasOwnProperty('msg')) {
            errorObject = res
          }
          // if (index === len - 1) {
            // console.log(!isNaN(Number(oi)), !isNaN(Number(sb)), !isNaN(Number(rt)))
          if (errorObject.msg) {
            message = errorObject.msg
          }
          if (!isNaN(Number(rt)) && isNaN(Number(sb)) && isNaN(Number(oi))) {
            // let str2 = 'SB Allowance & OI Allowance cannot be empty.'
            // message.push(str2)
          } else if (!isNaN(Number(rt)) && !isNaN(Number(sb)) && isNaN(Number(oi))) {
            // if (sb > rt) {
            //   let str2 = `\n NOTE: Sum of 'SB Allowance' & 'OI Allowance' \n` +
            //             ` should be lesser than or equal to 'Retail Savings'`
            //   message.push(str2)
            // }
          } else if (!isNaN(Number(rt)) && !isNaN(Number(oi)) && isNaN(Number(sb))) {
            // if (oi > rt) {
            //   let str2 = `\n NOTE: Sum of 'SB Allowance' & 'OI Allowance' \n` +
            //             ` should be lesser than or equal to 'Retail Savings'`
            //   message.push(str2)
            // }
          } else if (!isNaN(Number(oi)) && !isNaN(Number(sb)) && !isNaN(Number(rt))) {
            // console.log(oi, sb, rt)
            // if (oi + sb > rt) {
            //   let str2 = `\n NOTE: Sum of 'SB Allowance' & 'OI Allowance' \n` +
            //             ` should be lesser than or equal to 'Retail Savings'`
            //   message.push(str2)
            // }
          }
          // }
        }
        if (message.length) {
          return message
        }
      }
    },
    submitApproveLock () {
      this.previewDataArray = []
      this.previewHeaderArray = []
      for (let h = 0; h < this.headers.length; h++) {
        if (h === 0 || h === this.rrPos || h === this.sbPos || h === this.oiPos || h === this.srsPos || h === this.srPos || h === this.fundPos || h === this.maPos) {
          this.previewHeaderArray.push(this.headers[h])
        }
      }
      this.information.forEach(item => {
        if (item.change) {
          let innerArray = []
          innerArray.push(item[0])
          innerArray.itemId = item.itemId
          for (let i = 0; i < item.length; i++) {
            switch (i) {
              case this.rrPos:
                innerArray.push(item[i])
                break
              case this.sbPos:
                innerArray.push(item[i])
                break
              case this.oiPos:
                innerArray.push(item[i])
                break
              case this.srsPos:
                innerArray.push(item[i])
                break
              case this.srPos:
                innerArray.push(item[i])
                break
              case this.fundPos:
                innerArray.push(item[i])
                break
              case this.maPos:
                innerArray.push(item[i])
                break
              default:
            }
          }
          this.previewDataArray.push(innerArray)
        }
      })
      let clone = cloneDeep(this.previewDataArray)
      clone.forEach(item => {
        item[0].arrow_for_close = false
        item.forEach(record => {
          record.editable = false
        })
      })
      this.editedHeaders = this.previewHeaderArray
      this.editedFields = clone

      let submitObject = {}

      let itemRecord = {}
      this.previewDataArray.forEach(item => {
        let obj = {}

        for (let i = 1; i < item.length; i++) {
          if (this.previewHeaderArray[i]) {
            let key = this.previewHeaderArray[i].key
            obj[key] = item[i].value
          }
        }
        itemRecord[item.itemId] = obj
        // finalApprovedItemArray.push(itemRecord)
      })
      submitObject['data'] = itemRecord
      submitObject['offerId'] = this.gettersSelectedOffer.id
      submitObject['period'] = this.gettersOfferFilterInput.period.id
      if (clone.length > 0) {
        this.code = APPROVE_WITH_CHANGES
      } else {
        this.editedHeaders = []
        this.editedFields = []
        this.code = APPROVE_WITH_NO_CHANGES
      }
      this.confirmEventApproveWithChanges({preview: this.confirmData, submit: submitObject})
      // let submitObject = {}
      // submitObject['data'] = this.approveWithLockInput
      // submitObject['offerId'] = this.gettersSelectedOffer.id
      // submitObject['period'] = this.gettersOfferFilterInput.period.id
      // let message = this.validateCondition(this.approveWithLockInput)
      // if (message && message.length) {
      //   this.pop({
      //     header: 'Validation Failed!',
      //     message: message,
      //     type: 'ERROR'
      //   })
      // } else {
      //   this.collectEditableItemWiseData()
      //   if (Object.keys(this.modifiedIndexValuePair).length > 0) {
      //     this.code = CODE.APPROVE_WITH_CHANGES
      //     this.editedHeaders = this.finalApprovedOfferHeaders(this.modifiedIndexValuePair)
      //     this.editedFields = this.finalApprovedOfferData(this.modifiedIndexValuePair)
      //     this.editedFields.forEach(array => {
      //       array[0].arrow_for_close = false
      //     })
      //     this.editedHeaders.unshift('Items')
      //   } else {
      //     this.editedHeaders = []
      //     this.editedFields = []
      //     this.code = CODE.APPROVE_WITH_NO_CHANGES
      //   }
      //   // console.log(this.confirmData, submitObject)
      //   this.confirmEventApproveWithChanges({preview: this.confirmData, submit: submitObject})
      // }
    },
    collectEditableItemWiseData () {

    },
    modifyTableHeightByData (el) {
      let tableHeightAdjustment = new TableHeightByFixedWidth(
        this.information,
        this.scrollableChildrenWidth,
        '1.3rem',
        '1rem'
      )
      tableHeightAdjustment.modifyTableRowHeight(el)
    },
    closePopUp (value) {

    },
    finalApprovedOfferData (obj) {
      let localInformation = cloneDeep(this.information)
      localInformation.pop()
      return localInformation.map((e, j) => {
        return e.filter((records, i) => {
          if (i === 0) {
            return e
          }
          let itemId = this.information[j].itemId
          if (i in obj) {
            e[i].editable = false
            e[i].value = obj[i]
            return e
          }
          if (obj && obj.hasOwnProperty(itemId)) {
            let data = obj[itemId]
            if (data && typeof data[i] !== 'undefined') {
              e[i].editable = false
              e[i].value = data[i]
              return e
            }
          }
        })
      })
    },
    finalApprovedOfferHeaders (obj) {
      let localHeaders = cloneDeep(this.headers)
      let result = []
      for (let j = 0; j < this.information.length; j++) {
        let itemId = this.information[j].itemId
        let c = -1
        localHeaders.filter(function (header) {
          c++
          if (c in obj) {
            result.push(header)
            result = unionBy(result, result)
            return header
          }
          if (obj && itemId && obj.hasOwnProperty(itemId)) {
            let data = obj[itemId]
            if (data && data[c]) {
              result.push(localHeaders[c])
              result = unionBy(result, result)
              return localHeaders[c]
            }
          }
        })
      }
      return result
    }
  },
  mounted () {
    this.scrollableWidth = this.getScrollableWidth()
  },
  updated () {
    this.$nextTick(() => {
      this.scrollableWidth = this.getScrollableWidth()
    })
  },
  beforeUpdate () {
    this.buttonCondtion()
  },
  created () {
    // window.eventBus.$on('acceptConfirm', (data) => {
    //   console.log('acceptConfirm', data)
    //   this.popupType = ''
    //   if (data && data.code === 'approveWithChanges') {
    //     this.submitOfferLock(this.approveWithLockInput)
    //   }
    // })
    // window.eventBus.$on('cancelConfirm', (data) => {
    //   console.log('cancelConfirm')
    //   this.confirmEventApproveWithChanges(false)
    //   // this.confirmPopUp = false
    // })
    if (this.gettersAggInputData.storeLevel && this.gettersAggInputData.storeLevel.id) {
      this.fetchApproveWithChangs({ offerId: this.gettersSelectedOffer.id, storeLevel: this.gettersAggInputData.storeLevel.id })
    }
  },
  components: {
    DataTable,
    PopUp
  }
}
</script>

<style lang="css" scoped>
  .scrollWrapper {
    height: 20px;
    overflow-x: scroll;
    z-index: 1;
    right: 10.5rem;
    top:3.4rem;
    position: fixed;
  }
  .simulateScrollDiv {
    height: 1px;
  }
  .inline-block {
    /*padding: 1.5rem;*/
    display: inline-block;
    vertical-align: top;
  }

  .scrollable {
    overflow: auto;
  }
  #selectedOffersDataContainer {
    background: white;
  }
</style>



// WEBPACK FOOTER //
// ApproveWithChanges.vue?617db9f1